"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var dayjs_1 = __importDefault(require("dayjs"));
var customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
var duration_1 = __importDefault(require("dayjs/plugin/duration"));
exports.FULL_FORM_DATE_FORMAT = "DD / MM / YYYY";
exports.MOVED_IN_FORM_DATE_FORMAT = "MM / YYYY";
dayjs_1.default.extend(customParseFormat_1.default);
dayjs_1.default.extend(duration_1.default);
function isValidDate(dateString) {
  return dayjs_1.default(dateString, exports.FULL_FORM_DATE_FORMAT, true).isValid();
}
exports.isValidDate = isValidDate;
function isHistoricDate(inputDate) {
  var granularity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "day";
  return dayjs_1.default(inputDate).isBefore(dayjs_1.default(), granularity);
}
exports.isHistoricDate = isHistoricDate;
function isBeforeNowMovedInDate(dateString) {
  return typeof dateString === "string" && dayjs_1.default(dateString, exports.MOVED_IN_FORM_DATE_FORMAT, true).isValid() && dayjs_1.default(dateString, exports.MOVED_IN_FORM_DATE_FORMAT, true).isBefore(dayjs_1.default()) || "Please enter a valid date";
}
exports.isBeforeNowMovedInDate = isBeforeNowMovedInDate;
function isValidMovedInDate(dateString) {
  return dayjs_1.default(dateString, exports.MOVED_IN_FORM_DATE_FORMAT, true).isValid();
}
exports.isValidMovedInDate = isValidMovedInDate;
function olderThan18(dateString) {
  return dayjs_1.default().diff(dayjs_1.default(dateString, exports.FULL_FORM_DATE_FORMAT), "years", false) > 17;
}
exports.olderThan18 = olderThan18;
// Should change name to timeFromToday
exports.daysFromToday = function (dateString, format) {
  var today = dayjs_1.default();
  var testDate = dayjs_1.default(dateString);
  return dayjs_1.default(dateString).isValid() ? Math.round(testDate.diff(today, format)) : undefined;
};
exports.stringToDate = function (date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "YYYY-MM-DD";
  return dayjs_1.default(date, format).toDate();
};
exports.formDateStringToDate = function (formDate) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    includesDay: false,
    appendCurrentTime: false
  };
  var format = options.includesDay ? exports.FULL_FORM_DATE_FORMAT : exports.MOVED_IN_FORM_DATE_FORMAT;
  var result = dayjs_1.default(formDate, format, true);
  if (result.isValid()) {
    return result.toDate();
  }
  return null;
};
exports.formDateStringToDateString = function (formDate) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    includesDay: false,
    appendCurrentTime: false
  };
  var format = options.includesDay ? exports.FULL_FORM_DATE_FORMAT : exports.MOVED_IN_FORM_DATE_FORMAT;
  var result = dayjs_1.default(formDate, format, true);
  if (!result.isValid()) return "";
  if (options.appendCurrentTime) {
    var now = dayjs_1.default();
    result = result.set("h", now.hour()).set("m", now.minute()).set("s", now.second());
  }
  return result.toISOString();
};
exports.calcFromDate = function (date, format) {
  if (!isValidMovedInDate(date)) {
    return undefined;
  }
  var dateDuration = dayjs_1.default.duration(dayjs_1.default().diff(dayjs_1.default(date, exports.MOVED_IN_FORM_DATE_FORMAT)));
  return format === "year" ? dateDuration.years() : dateDuration.months() + 1;
};
exports.calcToDate = function (month, year) {
  return !Number.isNaN(month) && !Number.isNaN(year) ? dayjs_1.default().subtract(year, "year").subtract(month - 1, "month").format(exports.MOVED_IN_FORM_DATE_FORMAT) : "";
};
exports.movedInToDateString = function (formDate) {
  var result = dayjs_1.default(formDate, exports.MOVED_IN_FORM_DATE_FORMAT, true);
  if (result.isValid()) {
    return result.add(15, "day").toISOString();
  }
  return "";
};
exports.dateToMovedIn = function (dateString) {
  var date = dayjs_1.default(dateString);
  return date.isValid() ? date.format(exports.MOVED_IN_FORM_DATE_FORMAT) : "";
};
exports.formatTodaysDate = function (format) {
  return dayjs_1.default().format(format);
};
exports.formatDate = function (date, format) {
  return dayjs_1.default(date).format(format);
};
var isDateExcluded = function isDateExcluded(date, excludedDates) {
  return excludedDates.some(function (excludedDate) {
    return dayjs_1.default(excludedDate).isSame(date, "day");
  });
};
exports.addDays = function (startDate, numDays) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    excludeWeekends: true,
    excludedDates: []
  };
  var date = dayjs_1.default(startDate);
  while (numDays > 0) {
    date = date.add(1, "day");
    var isWeekend = [0, 6].includes(date.day());
    if (options.excludeWeekends && isWeekend) {
      continue;
    }
    if (options.excludedDates && isDateExcluded(date, options.excludedDates)) {
      continue;
    }
    numDays--;
  }
  return date.toDate();
};